(() => {
    console.log('%c👍🏼 Homepage Videos', 'color: yellow');
    const sections = document.querySelectorAll('.homepage-video-section');
    
    sections.forEach((section) => {
        // create an IntersectionObserver instance foreach section. when it's scrolled into view, it should add a class to the section
        const infoSection = section.querySelector('.homepage-video-section__info');
        const video = section.querySelector('video');

        const videoObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    //console.log('video section is in view');
                    video.play();
                } else {
                    //console.log('video section is out of view');
                    video.pause();
                }
            });
        }, {
            root: null, // use the viewport as the root
            rootMargin: '0px', // no margin around the root
            threshold: 0.10 // trigger when 10% of the section is in view
        });

        videoObserver.observe(section);

        if (!infoSection) {
            return;
        }
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    //console.log('section is in view');
                    infoSection.classList.remove('opacity-0', 'translate-y-full');
                }
            });
        }, {
            root: null, // use the viewport as the root
            rootMargin: '0px', // no margin around the root
            threshold: 0.90 // trigger when 90% of the section is in view
        });

        observer.observe(section);

        const fadeOutObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    //console.log('section is not in view');
                    //infoSection.classList.remove('opacity-0', 'translate-y-full');
                    infoSection.classList.add('opacity-0', 'translate-y-full');
                }
            });
        }, {
            root: null, // use the viewport as the root
            rootMargin: '0px', // no margin around the root
            threshold: 0.50 // trigger when 40% of the section is in view
        });

        fadeOutObserver.observe(section);
    });
})();